import React, { useEffect, useState } from "react";
import {
	IonCard,
	IonCardContent,
	IonCardHeader,
	IonCardSubtitle,
	IonCardTitle,
	IonItem,
	IonToolbar,
	IonButton,
	useIonAlert,
	IonCol,
	IonGrid,
	IonRow,
	IonLabel,
	IonIcon,
	IonPage,
	IonHeader,
	IonButtons,
	IonMenuButton,
	IonTitle,
	IonContent,
	IonNote,
	IonModal,
	IonInput,
	IonText,
	IonSearchbar
} from "@ionic/react";
import { add, close } from "ionicons/icons";
import axios from "axios";
import { useHistory } from "react-router-dom";
import moment from "moment";
import { useTranslation } from "react-i18next";
import NoDataFound from "../../components/NoDataFound";
import PlusIcon from "../../components/PlusIcon";
import { Button, Phone } from "../../controls";
import useStore from "../../store/store";
import AnimatedPage from "../AnimatedPage";
import validator from "validator";

const Tenants: React.FC = () => {
	const { t } = useTranslation();
	const [data, setData] = useState<any[]>([]);
	const [presentAlert] = useIonAlert();
	const history = useHistory();
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [keyword, setKeyword] = useState<string>("");

	let [name, setName] = useState("");
	let [email, setEmail] = useState("");
	let [phone, setPhone] = useState("");
	let [error, setError] = useState("");
	let [toEditId, setToEditId] = useState("");
	let [msg, setMsg] = useState("");
	const { setIsLoading, token } = useStore((state: any) => state);

	const getData = () => {
		axios
			.post(
				`${process.env.REACT_APP_API_URL}/tenants/all`,
				{
					keyword: keyword
				},
				{
					headers: { rentapp_auth: token }
				}
			)
			.then(res => setData(res.data))
			.catch(err => console.log(err));
	};

	useEffect(() => {
		getData();
	}, [keyword]);

	const handleEdit = (id: any) => history.push(`/tenant/u/${id}`);
	const seeDetails = (id: any) => history.push(`/tenant/${id}`);

	const handleDelete = (id: any) => {
		presentAlert({
			header: `${t("sureToDel")}`,
			buttons: [
				{
					text: `${t("cancel")}`,
					role: "cancel"
				},
				{
					text: `${t("yes")}`,
					role: "confirm",
					handler: () => {
						axios
							.delete(
								`${process.env.REACT_APP_API_URL}/tenants/${id}`,
								{
									headers: { rentapp_auth: token }
								}
							)
							.then(res => {
								getData();
							})
							.catch(err => console.log(err));
					}
				}
			]
		});
	};

	const addTenant = () => {
		if (name === "" || email === "" || phone === "") {
			setError(
				"All fields are required. Please fill all input fields before submitting the form."
			);
			return;
		}
		if (!validator.isEmail(email)) {
			setError("Please enter a valid email.");
			return;
		}

		let joined = new Date().toISOString();
		let obj = { name, email, phone, joined };

		if (toEditId === "") {
			axios
				.post(`${process.env.REACT_APP_API_URL}/tenants/`, obj, {
					headers: { rentapp_auth: token }
				})
				.then(res => {
					clearForm();
					setIsModalOpen(false);
					getData();
				})
				.catch(err => {
					setError(`${err.response.data}`);
				});
		} else {
			axios
				.put(
					`${process.env.REACT_APP_API_URL}/tenants/${toEditId}`,
					obj,
					{
						headers: { rentapp_auth: token }
					}
				)
				.then(res => {
					setToEditId("");
					clearForm();
					setIsModalOpen(false);
					getData();
				})
				.catch(err => {
					setError(`${err.response.data}`);
				});
		}
	};

	const clearForm = () => {
		setName("");
		setEmail("");
		setPhone("");
		setToEditId("");
		setError("");
	};

	return (
		<>
			<IonModal
				isOpen={isModalOpen}
				trigger="open-modal"
				backdropDismiss={false}
			>
				<IonHeader>
					<IonToolbar>
						{toEditId === "" ? (
							<IonTitle>{t("addNewTenant")}</IonTitle>
						) : (
							<IonTitle>{t("editTenant")}</IonTitle>
						)}
						<IonButtons slot="end">
							<IonButton onClick={() => setIsModalOpen(false)}>
								<IonIcon icon={close}></IonIcon>
							</IonButton>
						</IonButtons>
					</IonToolbar>
				</IonHeader>
				<IonContent>
					<IonGrid>
						<IonRow>
							<IonCol size="12">
								<IonItem>
									<IonLabel position="floating">
										{t("name")}
									</IonLabel>
									<IonInput
										placeholder="Enter Name"
										value={name}
										onIonInput={(e: any) =>
											setName(e.target.value)
										}
										onKeyUp={() => {
											setError("");
											setMsg("");
										}}
									></IonInput>
								</IonItem>
							</IonCol>
							<IonCol size="12">
								<IonItem>
									<IonLabel position="floating">
										{t("email")}
									</IonLabel>
									<IonInput
										placeholder="Enter Email"
										value={email}
										onIonInput={(e: any) =>
											setEmail(e.target.value)
										}
										onKeyUp={() => {
											setError("");
											setMsg("");
										}}
									></IonInput>
								</IonItem>
							</IonCol>
							<IonCol size="12">
								<Phone
									label={t("phone")}
									value={phone}
									onChange={setPhone}
								/>
							</IonCol>
							<IonCol size="12" className="ion-text-center">
								<Button
									text={
										toEditId === ""
											? t("addTenant")
											: t("saveData")
									}
									icon={add}
									onClick={addTenant}
								></Button>
							</IonCol>
							<IonCol size="12" className="ion-text-center">
								<IonText color="danger">{error}</IonText>
								<IonText color="success">{msg}</IonText>
							</IonCol>
						</IonRow>
					</IonGrid>
				</IonContent>
			</IonModal>

			<IonPage>
				<IonHeader>
					<IonToolbar>
						<IonButtons slot="start">
							<IonMenuButton />
						</IonButtons>
						<IonButtons slot="end">
							<IonButton
								onClick={(e: any) => {
									e.preventDefault();
									history.push(`/tenants/new`);
								}}
							>
								<PlusIcon />
							</IonButton>
						</IonButtons>
						<IonTitle>{t("tenants")}</IonTitle>
					</IonToolbar>
				</IonHeader>

				<IonContent fullscreen>
					<IonHeader collapse="condense">
						<IonToolbar>
							<IonTitle size="large">{t("tenants")}</IonTitle>
						</IonToolbar>
					</IonHeader>
					<IonGrid>
						<IonRow>
							<IonSearchbar
								showClearButton="focus"
								debounce={500}
								onIonChange={e =>
									setKeyword(e.target.value || "")
								}
							></IonSearchbar>
						</IonRow>
						<IonRow>
							{data.length === 0 && <NoDataFound />}
							{data.length > 0 &&
								data.map((elem, index) => {
									return (
										<IonCol
											size-xs="12"
											size-sm="12"
											size-md="6"
											key={index}
										>
											<IonCard
												color="light"
												style={{
													cursor: "pointer"
												}}
												title="Click to see details"
											>
												<IonCardHeader>
													<IonCardTitle
														style={{
															fontSize: 20,
															fontWeight: "bold"
														}}
													>
														{elem?.name}
													</IonCardTitle>
													<IonCardSubtitle>
														{elem?.email}
													</IonCardSubtitle>
												</IonCardHeader>
												<IonCardContent
													style={{
														cursor: "pointer",
														paddingBottom: 0
													}}
												>
													<IonLabel>
														<Phone
															displayType="text"
															value={elem?.phone}
														/>
													</IonLabel>
													<br />
													<IonNote
														style={{
															fontSize: 14
														}}
													>
														{moment(
															elem?.joined
														).format("DD-MMM-YYYY")}
													</IonNote>
												</IonCardContent>
												<div>
													<IonButton
														fill="clear"
														color="dark"
														id="open-modal"
														onClick={() =>
															handleEdit(
																elem?._id
															)
														}
													>
														{t("edit")}
													</IonButton>
													<IonButton
														fill="clear"
														color="danger"
														onClick={() =>
															handleDelete(
																elem?._id
															)
														}
													>
														{t("delete")}
													</IonButton>
												</div>
											</IonCard>
										</IonCol>
									);
								})}
						</IonRow>
					</IonGrid>
				</IonContent>
			</IonPage>
		</>
	);
};

export default Tenants;
